import type { QuickbetSelection } from '@core/Areas/Quickbet/types'
import { loadBet } from '@core/Areas/ShareBet/LoadBet'
import { isKambiSportBetDetails } from '@core/Areas/ShareBet/LoadBet/typeGuards'
import type { LoadBetDetails } from '@core/Areas/ShareBet/LoadBet/types'
import { trackShareBetLinkOpen } from '@core/Areas/ShareBet/helpers/analytics'
import { getShareBetDataWithKey } from '@core/Areas/ShareBet/helpers/api'

export async function buildSharedBetSelections({
  shareId,
  accountNumber,
}: {
  shareId: string | null
  accountNumber: number | null
}): Promise<QuickbetSelection[]> {
  if (!shareId) {
    throw new Error('No Share Provided')
  }

  const { data, accountNumber: origin } = await getShareBetDataWithKey(shareId, accountNumber)

  const { selections } = await loadBet(data, { location: 'share-bet', origin })

  trackShareBetLinkOpen({
    share_origin: origin,
    betType: getBetTypeForLinkOpenTracking(data),
  })

  return selections
}

// =============
// Local Helpers
// =============

function getBetTypeForLinkOpenTracking(data: LoadBetDetails[]): string {
  if (data.length > 0 && isKambiSportBetDetails(data[0])) {
    const betType = data[0].betSelectionType
    if (betType === 'same-game-multi') return betType
    return `sports-${betType}`
  }

  return data.length === 1 ? 'single' : 'multi'
}
